// extractResponseData :: ApolloQueryResult<any> -> data
export function extractResponseData<P extends { data?: R }, R>(
  response: P
): R | Error {
  return response.data || Error('No Data Returned from the HTTP Call');
}
